import { b as B } from "../table-DtH1DJ20.js";
const P = "marzipan.table.prefs";
function I() {
  try {
    const o = localStorage.getItem(P);
    if (o) return { ...N(), ...JSON.parse(o) };
  } catch {
  }
  return N();
}
function E(o) {
  try {
    localStorage.setItem(P, JSON.stringify(o));
  } catch {
  }
}
function N() {
  return { alignment: "left", headerColor: "default" };
}
function G(o, c) {
  const a = o.textarea, d = a.selectionStart ?? 0, u = a.selectionEnd ?? 0;
  a.setRangeText(c, d, u, "end"), o.updatePreview(), a.focus();
}
function q(o = {}) {
  const c = Math.max(1, o.maxRows ?? 10), a = Math.max(1, o.maxColumns ?? o.maxCols ?? 10), d = o.label ?? "▦", u = o.title ?? "Insert table";
  return (f) => {
    const L = f.container.querySelector(".marzipan-toolbar") ?? f.container, i = I(), s = document.createElement("button");
    s.type = "button", s.className = "marzipan-toolbar-button mz-btn-tablegrid", s.title = u, s.textContent = d, s.setAttribute("aria-label", u);
    let n = null, x = 0, b = 0;
    function p() {
      n?.remove(), n = null, document.removeEventListener("click", h, !0), window.removeEventListener("resize", p), window.removeEventListener("scroll", p, !0);
    }
    function h(r) {
      n && (r.target instanceof Node && (n.contains(r.target) || s.contains(r.target)) || p());
    }
    function A() {
      if (x < 1 || b < 1) return;
      const r = Array(b).fill(i.alignment), m = B({
        rows: x,
        cols: b,
        alignment: r,
        headerColor: i.headerColor !== "default" ? i.headerColor : void 0
      });
      G(f, `
${m}
`), p();
    }
    function R() {
      if (n) {
        p();
        return;
      }
      n = document.createElement("div"), n.className = "mz-pop mz-tablegrid-pop";
      const r = document.createElement("div");
      r.className = "mz-tablegrid", r.style.setProperty("--r", String(c)), r.style.setProperty("--c", String(a));
      const m = document.createElement("div");
      m.className = "mz-tablegrid-status", m.textContent = "Hover to select size";
      for (let t = 1; t <= c; t++)
        for (let e = 1; e <= a; e++) {
          const l = document.createElement("div");
          l.className = "mz-cell", l.dataset.r = String(t), l.dataset.c = String(e), l.onmouseenter = () => {
            x = t, b = e, m.textContent = `${t} × ${e}`, r.querySelectorAll(".mz-cell").forEach((z) => {
              const M = Number(z.dataset.r), $ = Number(z.dataset.c);
              z.classList.toggle("sel", M <= t && $ <= e);
            });
          }, l.onclick = () => A(), r.appendChild(l);
        }
      n.appendChild(r), n.appendChild(m);
      const g = document.createElement("div");
      g.className = "mz-table-options";
      const v = S("Align"), y = [];
      ["left", "center", "right"].forEach((t) => {
        const e = document.createElement("button");
        e.type = "button", e.className = "mz-opt-btn" + (i.alignment === t ? " active" : ""), e.textContent = t === "left" ? "⬅" : t === "center" ? "⬌" : "➡", e.title = t.charAt(0).toUpperCase() + t.slice(1) + " align", e.onclick = () => {
          i.alignment = t, E(i), y.forEach((l) => l.classList.toggle("active", l === e));
        }, y.push(e), v.content.appendChild(e);
      }), g.appendChild(v.row);
      const w = S("Header"), C = [];
      [
        { key: "default", color: "", title: "Default" },
        { key: "pink", color: "rgba(236,72,153,0.7)", title: "Pink" },
        { key: "purple", color: "rgba(139,92,246,0.7)", title: "Purple" },
        { key: "blue", color: "rgba(59,130,246,0.7)", title: "Blue" },
        { key: "cyan", color: "rgba(6,182,212,0.7)", title: "Cyan" },
        { key: "green", color: "rgba(16,185,129,0.7)", title: "Green" },
        { key: "amber", color: "rgba(245,158,11,0.7)", title: "Amber" }
      ].forEach((t) => {
        const e = document.createElement("button");
        e.type = "button", e.className = "mz-opt-btn mz-opt-color" + (i.headerColor === t.key ? " active" : ""), e.title = t.title + " header", t.key === "default" ? e.textContent = "∅" : (e.textContent = "●", e.style.color = t.color), e.onclick = () => {
          i.headerColor = t.key, E(i), C.forEach((l) => l.classList.toggle("active", l === e));
        }, C.push(e), w.content.appendChild(e);
      }), g.appendChild(w.row), n.appendChild(g), document.body.appendChild(n);
      const k = s.getBoundingClientRect();
      n.style.left = `${Math.round(window.scrollX + k.left)}px`, n.style.top = `${Math.round(window.scrollY + k.bottom + 6)}px`, setTimeout(() => {
        document.addEventListener("click", h, !0), window.addEventListener("resize", p), window.addEventListener("scroll", p, !0);
      }, 0);
    }
    s.onclick = R, L.appendChild(s);
  };
}
function S(o) {
  const c = document.createElement("div");
  c.className = "mz-opt-row";
  const a = document.createElement("span");
  a.className = "mz-opt-label", a.textContent = o;
  const d = document.createElement("div");
  return d.className = "mz-opt-group", c.appendChild(a), c.appendChild(d), { row: c, content: d };
}
const H = `
.mz-pop {
  position: absolute; z-index: 9999; user-select: none;
  background: var(--mz-pop-bg, #111); color: var(--mz-pop-fg, #eee);
  border: 1px solid var(--mz-pop-bd, #333); border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0,0,0,.35); padding: 10px;
}
.mz-tablegrid {
  display: grid; grid-template-rows: repeat(var(--r), 16px);
  grid-template-columns: repeat(var(--c), 16px);
  gap: 4px; margin: 4px;
}
.mz-tablegrid .mz-cell {
  width: 16px; height: 16px; border-radius: 4px;
  background: var(--mz-cell-bg, #1d1f23); border: 1px solid var(--mz-cell-bd, #2b2f36);
}
.mz-tablegrid .mz-cell.sel {
  background: var(--mz-cell-sel-bg, #2f6feb); border-color: var(--mz-cell-sel-bd, #3b82f6);
}
.mz-tablegrid-status { font-size: 12px; opacity: .8; padding: 6px 4px 2px; text-align: center; }
.mz-btn { cursor: pointer; }
.mz-table-options {
  border-top: 1px solid var(--mz-pop-bd, #333);
  margin-top: 8px; padding-top: 8px;
  display: flex; flex-direction: column; gap: 6px;
}
.mz-opt-row {
  display: flex; align-items: center; gap: 8px;
}
.mz-opt-label {
  font-size: 11px; font-weight: 600; opacity: 0.6;
  min-width: 42px; text-transform: uppercase; letter-spacing: 0.5px;
}
.mz-opt-group {
  display: flex; gap: 3px; flex-wrap: wrap;
}
.mz-opt-btn {
  background: var(--mz-cell-bg, #1d1f23);
  border: 1px solid var(--mz-cell-bd, #2b2f36);
  color: var(--mz-pop-fg, #ccc);
  border-radius: 5px; padding: 2px 7px; font-size: 11px;
  cursor: pointer; transition: all 0.15s ease;
  font-family: inherit; line-height: 1.4;
}
.mz-opt-btn:hover {
  border-color: #555; background: #252830;
}
.mz-opt-btn.active {
  background: var(--accent, #2f6feb);
  border-color: var(--accent, #3b82f6);
  color: #fff; font-weight: 600;
}
.mz-opt-color { font-size: 14px; padding: 2px 5px; min-width: 22px; }
`;
export {
  q as tableGridPlugin,
  H as tableGridStyles
};
//# sourceMappingURL=tableGridPlugin.js.map
